import {
  Dialog,
  DialogTitle,
  List,
  ListItem,
  Typography,
  Divider,
} from "@mui/material";
import { Fragment } from "react";

const InternetFrastructureList = ({
  internetFrastructure,
  open,
  setOpen,
}: any) => {
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">İnternet Altyapısı</DialogTitle>
      <List
        sx={{
          width: "100%",
          bgcolor: "background.paper",
        }}
      >
        {internetFrastructure?.map((item: any, index: number) => (
          <Fragment key={index}>
            <ListItem alignItems="flex-start">
              <Typography
                sx={{ display: "inline" }}
                component="span"
                variant="body2"
                color="text.primary"
              >
                <strong> {item.serviceType} </strong>
                {item.santraL_HIZMET_VERILEBILIRLIK
                  ? ""
                  : "Santral Hizmet verilemiyor"}{" "}
                {item.santraL_HIZMET_VERILEBILIRLIK
                  ? ` Maks Hız: ${item.hiz} Mbps`
                  : null}
                {item.santraL_HIZMET_VERILEBILIRLIK
                  ? ` - Santrale Mesafe yaklaşık 
                                            ${item.mesafe} Mt.`
                  : null}
                {item.santraL_HIZMET_VERILEBILIRLIK && item.fiber
                  ? ` - Fiber`
                  : null}
                {item.santraL_HIZMET_VERILEBILIRLIK && item.boS_PORT
                  ? ` - Boş Port bulunmaktadır`
                  : null}
              </Typography>
            </ListItem>
            <Divider variant="inset" component="li" />
          </Fragment>
        ))}
      </List>
    </Dialog>
  );
};

export default InternetFrastructureList;
